import styled from 'styled-components';

export const ModalContainer = styled.div`
    .gi-modal__content {
        max-width: none;
    }
    .gi-modal__body {
        border-bottom: 30px;
    }

    .mt-0 {
        margin-top: 0;
    }

    .text-14 {
        font-size: 14px;
    }
`;

export const StyledModal = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .f-center {
        display: flex;
        align-items: center;
        column-gap: 10px;
    }

    .gap-2 {
        display: flex;
        gap: 10px;
    }
`;

export const CommonData = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    gap: 16px;
    .w-50p {
        width: 32%;
        flex-shrink: 0;
    }

    .margin-0 {
        margin: 0;
    }

    @media (max-width: 1087px) {
        flex-direction: column;
        .w-50p {
            width: 100%;
        }
    }
`;

export const Label = styled.label`
    display: inline-block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.gray3};
    text-transform: none;
    letter-spacing: 0rem;
    padding-top: 4px;
    padding-bottom: 4px;
`;

export const StyledField = styled.div`
    display: 'flex';
    gap: '20px';

    .date-picker,
    .shown.error--msg {
        padding: 8px;
        background-color: ${({ theme }) => theme.dangerLightest};
    }
    @media (max-width: 641px) {
        flex-direction: column;
        justify-content: center;
    }

    .gi-input {
        text-align: left;
        margin: 0;
    }
`;

export const OverrideTable = styled.table`
    width: 100%;
    margin-top: 24px;
    .pr-10 {
        padding-right: 10px;
    }
    span {
        color: ${({ theme }) => theme.dangerMain};
        margin-left: 5px;
    }
`;

export const Td = styled.td`
    padding-right: 10px;
    .gi-dropdown {
        align-items: flex-start;
        flex-direction: column;
        text-align: left;
        label {
            display: block;
        }
    }
    .p-14-0 {
        padding: 14px 0;
    }
`;

export const StyledDropdown = styled.div<{ width: string }>`
    .gi-dropdown__select {
        width: ${({ width }) => width};
    }
`;

export const InputContainer = styled.div`
    margin-top: 20px;
    label {
        font-size: 16px;
        color: ${({ theme }) => theme.infoMain};
        margin-bottom: 5px;
        display: block;

        span {
            color: ${({ theme }) => theme.dangerMain};
            margin-left: 5px;
        }
    }
`;

export const StyledNumberInput = styled.div`
    display: 'flex';
    gap: '20px';
`;

